import { LANG_ENG, ENDPOINT_NEWS_ENG, ENDPOINT_NEWS_SV } from '../../constants/strings';


const InternalHyperLinks = [
  {
    "text": "LLM",
    "translation": "[LLM]",
    "id": "g0cSE4J3Jy"
  },
  {
    "text": "o1",
    "translation": "[o1]",
    "id": "y3H9x5Y2mN"
  },
  {
    "text": "ChatGPT4o",
    "translation": "[ChatGPT4o]",
    "id": "KUwPPKPdOG"
  },
  {
    "text": "Claude",
    "translation": "[Claude]",
    "id": "xKpLmNqRds"
  },
  {
    "text": "Gemini",
    "translation": "[Gemini]",
    "id": "rgbI9RMVdF"
  },
  {
    "text": "AI-agenter",
    "translation": "[AI-agenter]",
    "id": "AKfGaabrUb"
  },
  {
    "text": "Custom GPT",
    "translation": "[Custom GPT]",
    "id": "zMSm9aRGjk"
  },
  {
    "text": "Chatbot",
    "translation": "[Chatbot](/chatbot)",
    "id": "chatbot"
  }

]

const addHyperLinks = (text, language) => {
  InternalHyperLinks.forEach(link => {
    if (text.includes(link.text)) {
      if (link.id === "chatbot") {
        text = text.replaceAll(link.text, link.translation);
      } else {
        text = text.replaceAll(link.text, link.translation + newsEndPoint(link, language));
      }
    }
  });
  return text;
}

const newsEndPoint = (link, language) => {
  return "(" + (language === LANG_ENG ? ENDPOINT_NEWS_ENG : ENDPOINT_NEWS_SV) + "/" + link.id + ")"
}

const addNewsHyperLinks = (text, currentNews, language) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(text, 'text/html');

  // Get all text nodes that are not within h1-h4 or a tags
  const walker = document.createTreeWalker(
    doc.body,
    NodeFilter.SHOW_TEXT,
    {
      acceptNode: (node) => {
        // Check all parent elements up to the root
        let currentParent = node.parentElement;
        while (currentParent) {
          if (currentParent.matches('h1, h2, h3, h4, a')) {
            return NodeFilter.FILTER_REJECT;
          }
          currentParent = currentParent.parentElement;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    }
  );

  let modifiedText = text;
  const textNodes = [];
  while (walker.nextNode()) {
    textNodes.push(walker.currentNode);
  }

  InternalHyperLinks.forEach(link => {
    if (link.id !== currentNews.id) {
      textNodes.forEach(node => {
        if (node.textContent.includes(link.text)) {
          const newText = node.textContent.replaceAll(
            link.text,
            link.translation + newsEndPoint(link, language)
          );
          modifiedText = modifiedText.replace(node.textContent, newText);
        }
      });
    }
  });

  return modifiedText;
}

export { InternalHyperLinks, addHyperLinks, addNewsHyperLinks };  